import { HrmAttendMonthlyDto, defaultHrmAttendMonthlyDto } from "src/dtos/hrmAttendMonthly/hrmAttendMonthlyDto";

/** 월근태 엔티티 필드에 사원 마스터의 조회·표시 필드를 더한 화면 행이다. */
export interface HRM2040_R01Dto extends HrmAttendMonthlyDto {
    empNm: string; // 사원명
    orgCd: string; // 현재 부서코드이며 조회·재집계 조건에도 사용한다.
    orgNm: string; // 현재 부서명
}

/** 빈 그리드 표시와 서버 응답의 화면 전용 필드 보완에 사용할 기본값이다. */
export const defaultHRM2040_R01Dto: HRM2040_R01Dto = {
    ...defaultHrmAttendMonthlyDto, // 엔티티 DTO의 모든 기본 필드를 포함한다.
    empNm: '',
    orgCd: '',
    orgNm: '',
};
